import { Link, useParams, Navigate } from 'react-router-dom';
import { ArrowLeft, Calendar } from 'lucide-react';
import { PageSEO } from '@/components/SEO';
import { getPostBySlug } from '@/data/blogPosts';

function formatDate(dateStr) {
  const [year, month, day] = dateStr.split('-');
  const date = new Date(year, month - 1, day);
  return date.toLocaleDateString('nb-NO', { day: 'numeric', month: 'long', year: 'numeric' });
}

export default function BloggPost() {
  const { slug } = useParams();
  const post = getPostBySlug(slug);

  if (!post) {
    return <Navigate to="/blogg" replace />;
  }

  return (
    <div>
      <PageSEO
        title={post.title}
        path={`/blogg/${post.slug}`}
        description={post.description}
      />
      {/* Hero */}
      <section className="pt-16 md:pt-20 pb-12 md:pb-16 bg-muted" data-testid="blogg-post-hero">
        <div className="max-w-3xl mx-auto px-6 lg:px-12">
          <Link
            to="/blogg"
            className="inline-flex items-center gap-2 font-manrope text-sm text-muted-foreground hover:text-accent transition-colors duration-300 mb-8"
          >
            <ArrowLeft className="w-4 h-4" />
            Tilbake til blogg
          </Link>
          <div className="flex items-center gap-3 text-muted-foreground mb-6">
            <Calendar className="w-4 h-4" />
            <span className="font-manrope text-sm">{formatDate(post.date)}</span>
            <span className="font-manrope text-sm">•</span>
            <span className="font-manrope text-sm">{post.readTime} lesning</span>
          </div>
          <h1 className="font-syne font-bold text-4xl md:text-5xl text-primary tracking-tight leading-[1.1]">
            {post.title}
          </h1>
        </div>
      </section>

      {/* Innhold */}
      <section className="py-16 md:py-24" data-testid="blogg-post-innhold">
        <div className="max-w-3xl mx-auto px-6 lg:px-12">
          <article
            className="blogg-innhold font-manrope text-muted-foreground leading-relaxed"
            dangerouslySetInnerHTML={{ __html: post.content }}
          />
          <div className="mt-16 pt-8 border-t border-border">
            <Link
              to="/kontakt"
              className="inline-flex items-center gap-2 font-syne font-bold text-sm uppercase tracking-wide px-8 py-4 bg-primary text-primary-foreground hover:bg-accent transition-colors duration-300"
            >
              Få en gratis konsultasjon
              <ArrowLeft className="w-4 h-4 rotate-180" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
